<template>
  <div class="lib-detail">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li><router-link to="/thu-vien">Thư viện</router-link></li>
          <li>
            <router-link :to="{name: 'library', query: {lop: dataPageLink.classId, mon: '0', nhom: '0', tab: '1'}}">
              {{ dataPageLink.className }}
            </router-link>
          </li>
          <li><span>{{ dataPageLink.title }}</span></li>
        </ul>
      </div>
    </div>
    <!-- haha - {{ dataPageLink }} -->
    <div class="lib-detail__body" v-if="dataPageLink && dataPageLink.imageUrl">
      <div class="container-hts">
        <!-- <div class="lib-back">
          <a href="javascript:;" @click="$router.go(-1)" class="secondary-color-txt"><i class="fa fa-angle-left"></i> Trở lại</a>
        </div> -->
        <div id="content_viewer" class="inner-img" :class="`inner-type-${dataPageLink.imageUrl ? checkTypeDocs(dataPageLink.imageUrl) : ''} ${relateMedia && relateMedia.length > 0 ? 'has-more' : ''}`">
          <PreviewBookImg
            v-if="dataPageLink && dataPageLink.fileName && dataPageLink.totalPage"
            :fileName="dataPageLink.fileName"
            :totalPage="dataPageLink.totalPage"
            :zoomData="1"
          />
          <PreviewVideo 
            v-else-if="dataPageLink.path && checkVideo(dataPageLink.path)"
            :pathView="dataPageLink.path ? `${appUrl}${dataPageLink.path}` : dataPageLink.path" 
            :mediaMore="relateMedia && relateMedia.length > 0 ? true : false"
          />
          <PreviewPdf 
            v-else-if="dataPageLink.imageUrl && (checkPdf(dataPageLink.imageUrl) || checkWord(dataPageLink.imageUrl))" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`" 
            :zoomData="scale" :class="{'view-default': scale === 1}" 
          />
          <Previewpptx 
            v-else-if="dataPageLink.imageUrl && checkPowerpoint(dataPageLink.imageUrl)" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`" 
            :zoomData="scale" 
            :class="{'view-default': scale === 1}" 
          />
          <PreviewImage 
            v-else-if="dataPageLink.imageUrl && checkImage(dataPageLink.imageUrl)" 
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`" 
          />
          <PreviewYoutube 
            v-else-if="dataPageLink.imageUrl && checkYoutube(dataPageLink.imageUrl)" 
            :pathView="dataPageLink.pathView"
            :autoplay="true"
            :mediaMore="relateMedia && relateMedia.length > 0 ? true : false"
          />
          <PreviewAudioPoster
            v-else-if="dataPageLink.imageUrl && checkAudio(dataPageLink.imageUrl)"
            :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`"
            :autoPlay="true"
            :poster="dataPageLink.posterLink ? `${urlImg}/${dataPageLink.posterLink}` : imgThumbAudio"
          />
          <!-- <template v-else-if="checkAudio(dataPageLink.imageUrl)">
            <div class="img-wrap text-center position-rel">
              <img :src="dataPageLink.posterLink ? `${urlImg}/${dataPageLink.posterLink}` : img404" :alt="dataPageLink.title">
              <PreviewAudio 
                class="d-none"
                :pathView="dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`"
                :autoPlay="true" 
              />
            </div>
          </template> -->
          <p v-else class="text-center color-light font-sanpro-semibold">Không tìm thấy tài liệu hiển thị</p>
        </div>
        <div class="lib-detail__content">
          <div class="lib-detail__content__title display-flex-center justify-content-between">
            <h1 class="font-size-24 font-sanpro-semibold primary-color-txt">{{ dataPageLink.title }}</h1>
            <div class="lib-detail__content__action">
              <span class="secondary-color-txt count-view">
                <i class="icon-eye secondary-color-txt font-size-18"></i>
                {{ dataPageLink.countView }}
              </span>

              <a
                v-if="dataPageLink.imageUrl"
                href="javascript:;"
                @click="handleDownloadFile(dataPageLink.linkViewFull ? dataPageLink.pathView : `${appUrl}${dataPageLink.pathView ? dataPageLink.pathView : dataPageLink.imageUrl}`, dataPageLink.title, dataPageLink.activeLearningId)"
              >
                <i class="icon-download"></i>
                <span class="secondary-color-txt count-download">{{ dataPageLink.countDownLoad }}</span>
              </a>

              <a href="javascript:;" class="primary-color font-size-16 font-sanpro-semibold" @click="handleShareMedia">
                <i class="icon-share-white"></i> Chia sẻ
              </a>
              
              <a href="javascript:;" class="primary-color font-size-16 font-sanpro-semibold" title="Hướng dẫn sử dụng chức năng thư viện"  @click="openModalNotiError"><i class="icon-question-2"></i></a>
            </div>
          </div>
          <div class="lib-detail__content__info">
            <div class="row">
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Môn:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.subjectName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Sách:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Bộ sách:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookGroupName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Chương / tuần:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookIndexParentName }}</span>
              </div>
              <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Bài:</label>
                <span class="primary-color-txt font-sanpro-light">{{ dataPageLink.bookIndexName }}</span>
              </div>
              <!-- <div class="col-xl-2 col-lg-4 col-sm-6">
                <label class="secondary-color-txt display-block">Loại học liệu:</label>
                <span class="primary-color font-sanpro-light" @click="showModalReadmore">
                  {{ dataPageLink.bookPageLinkGroupId === 1 && dataPageLink.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}
                </span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lib-detail__relate">
      <div class="container-hts">
        <!-- <h2 class="lib-detail__relate__title font-size-22 font-sanpro-semibold primary-color-txt">{{ dataPageLink.documentType }} Liên quan</h2> -->
        <h2 class="lib-detail__relate__title font-size-22 font-sanpro-semibold primary-color-txt">Video Liên quan</h2>
        <div class="lib-detail__relate__body">
          <swiper :options="{slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.ebook__next__0`, prevEl: `.ebook__prev__0`}}" @slideNextTransitionEnd="handleNextMedia" ref="swiper_relate">
            <swiperSlide 
              class="item position-rel" 
              v-for="(item, loc) of relateMedia" 
              :key="`book__${loc}`"
              :class="{'item--lock': (!item.isShowFree || item.isShowFree === 0) && !item.isActived}"
            >
              <a href="javascript:;" @click="directToMediaDetail(item)">
               <div class="item__media position-rel text-center aspect-ratio aspect-ratio--16-9">
                  <div class="img-wrap text-center" v-if="checkVideo(item.imageUrl)">
                    <img :src="item.posterLink ? handleResizeImg(item.posterLink) : img404" :alt="item.title">
                  </div>
                  <PreviewImage 
                    v-else-if="checkImage(item.imageUrl)" 
                    :pathView="isFullLink(item.imageUrl) ? item.imageUrl : handleResizeImg(item.imageUrl)" 
                  />
                  <PreviewYoutube 
                    v-else-if="checkYoutube(item.imageUrl)" 
                    :pathView="item.imageUrl"
                  />
                  <PreviewAudio 
                    v-else-if="checkAudio(item.imageUrl)" 
                    :pathView="isFullLink(item.imageUrl) ? item.imageUrl : `${appUrl}${item.imageUrl}`" 
                    class="evt-none"
                  />
                  <IconMedia class="item__icon" :dataSource="item" />
                </div>
                <div class="item__body">
                  <h3 class="item__title font-size-15 font-sanpro-semibold primary-color-txt">{{ item.title }}</h3>
                  <p class="font-size-13 secondary-color-txt margin-0">{{item.bookName}} - {{item.bookGroupName}}</p>
                </div>
              <!-- </router-link> -->
              </a>
              <!-- </div> -->
            </swiperSlide>
            <div class="swiper-button-prev ebook__prev__0" slot="button-prev"></div>
            <div class="swiper-button-next ebook__next__0" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
    <ModalReadMoreLinkType v-if="openModalReadmore" />
    <ModalShare />
    <modalShowHelp />
  </div>
</template>

<script>
  import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import { APP_CONFIG } from '@/utils/constants'
  import mixinsFiles from '@/components/content-files/mixinsFiles'
  import PreviewPdf from '@/components/content-files/PreviewPdf.vue'
  import Previewpptx from '@/components/content-files/Previewpptx.vue'
  import PreviewImage from '@/components/content-files/PreviewImage.vue'
  import PreviewYoutube from '@/components/content-files/PreviewYoutube.vue'
  import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
  import PreviewAudioPoster from '@/components/content-files/PreviewAudioPoster.vue'
  import PreviewBookImg from "@/components/content-files/PreviewBookImg.vue";
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import { getMediaDetailInLibs, getMediaRelateInLibs, apiUpdateCountdownloadActiveLesson, getDetailActiveLearning, getListReferentAtvLearn } from './../_api/'
  import IconMedia from './../_components/list/IconMedia.vue'
  import { getAuth } from '@/utils/jwt'
  import { EMAIL_PUBLIC } from '@/store/auth/constants'
  import { ID_MODAL_READ_LINK_TYPE } from './../_store/constants'
  import ModalReadMoreLinkType from './../_components/list/ModalReadMoreLinkType.vue'
  import ModalShare from '@/modules/libraries/_components/detail/ModalShare.vue'
  import modalShowHelp from '@/components/modal/modalShowHelp'
  import { replaceImageResize } from '@/helpers/functions'
  const img404 = require(`@/assets/images/img_404.jpg`)
  const imgThumbAudio = require(`@/assets/images/thumb-audio.png`)

  export default {
    name: 'DetailPageLinkLib',
    mixins: [ mixinsFiles ],
    components: {
      PreviewVideo,
      PreviewPdf,
      Previewpptx,
      PreviewImage,
      PreviewYoutube,
      PreviewAudio,
      PreviewAudioPoster,
      PreviewBookImg,
      swiper,
      swiperSlide,
      IconMedia,
      ModalReadMoreLinkType,
      ModalShare,
      modalShowHelp
    },
    data () {
      return {
        appUrl: APP_CONFIG.bookCdnUrl,
        cdnUrl: APP_CONFIG.cdnUrl,
        urlImg: APP_CONFIG.urlPlatformCmsImg,
        dataPageLink: {},
        relateMedia: [],
        paramSearchRelateMedia: {id: 0, pageIndex: 1, pageSize: 6},
        mediaRelateNotdata: false,
        img404,
        imgThumbAudio,
        authInfo: {},
        openModalReadmore: false,
        thumbnailUrl: '',
        nameRoute: this.$route.name,
        isShowVideo: 3

      }
    },
    // head: {
    //   title: function () {
    //     return {
    //       inner: this.dataPageLink.titlelink
    //     }
    //   },
    //   meta: [
    //     { name: 'description', content: 'Học liệu điện tử'},
    //     { property: 'og:title', content: this.dataPageLink.titleLink + ' - Hành trang số'},
    //     { property: 'og:site_name', content: 'Hành trang số'},
    //     { property: 'og:description', content: 'Học liệu điện tử'},
    //     { property: 'og:type', content: 'profile'},
    //     { property: 'og:url', content: `${window.location.origin}${this.$route.fullPath}` },
    //     { property: 'og:image', content: this.thumbnailUrl }
    //   ]
    // },

    // metaInfo() {
    //   return {
    //     title: this.dataPageLink.titleLink,
    //     // titleTemplate: 'Hành trang số',
    //     meta: [
    //       { name: 'description', content: 'Học liệu điện tử'},
    //       { property: 'og:title', content: this.dataPageLink.titleLink + ' - Hành trang số'},
    //       { property: 'og:site_name', content: 'Hành trang số'},
    //       { property: 'og:description', content: 'Học liệu điện tử'},
    //       { property: 'og:type', content: 'profile'},
    //       { property: 'og:url', content: `${window.location.origin}${this.$route.fullPath}` },
    //       { property: 'og:image', content: this.thumbnailUrl }
    //     ]
    //   }
    // },
    computed: {
      ...mapState('auth', ['loginPopupData']),
      ...mapState('common', ['mediaShareInfo']),
      queryRoute () {
        return this.$route.query
      }
    },
    watch: {
      loginPopupData(newVal) {
        if(newVal && Object.keys(newVal).length) {
          this.authInfo = newVal;
        }
      },
      'paramSearchRelateMedia': 'getDataRelateMedia',
      '$route': 'getInfoLib'
    },
    created () {
      this.actionCheckRouterHelp({nameRoute: this.nameRoute})
      this.getInfoLib();
      this.authInfo = getAuth();
      // console.log('route', this.$route)
    },
    beforeDestroy () {
      this.acSetMediaShareInfo({})
      // this.$emit('updateHead')
    },
    methods: {
      ...mapActions('auth', ['setToggleLoginForm']),
      ...mapActions('common', ['setLoading', 'acToggleModalActiveBook', 'acToggleModalShareMedia', 'acSetMediaShareInfo', 'acToggleModaShowHelp', 'actionCheckRouterHelp', 'actionGetVideoHelp', 'actionSetBookPageLinkId', 'actionSetInfoLibrary', 'actionSetBookIndexId']),

      openModalNotiError(){
        this.actionGetVideoHelp({isShowVideo: this.isShowVideo})
        this.acToggleModaShowHelp(true)
      },

      getInfoLib() {
        let self = this;
        self.setLoading(true);
        // Set relate params: 
        self.relateMedia = [];
        // Get detail
        // console.log('self.$router', self.$router);
        getDetailActiveLearning(self.$router.history.current.params.id).then(res => {
          // chắc k dùng đâu
          // if(res && res.data) {
          //   this.actionSetInfoLibrary({
          //     bookPageLinkId: res.data.bookPageLinkId,
          //   })
          //   this.actionSetBookIndexId(res.data.bookIndexId)
          // }
          if(res && res.data && !res.errors) {
            this.actionSetBookPageLinkId(res.data.bookPageLinkId)
            if (self.queryRoute && self.queryRoute.shared === window.location.origin && self.queryRoute.type_show !== '1' && !res.data.isActived) {
              if(self.authInfo && self.authInfo.email === EMAIL_PUBLIC) {
                self.setToggleLoginForm(true);
              } else {
                self.acToggleModalActiveBook(true)
              }
              self.$router.push({ name: 'library' })
            } else {
              self.dataPageLink = res.data;
              self.thumbnailUrl = res.data.posterLink ? `${self.urlImg}/${res.data.posterLink}` : `${self.appUrl}${res.data.imageUrl}`
              self.paramSearchRelateMedia = {...self.paramSearchRelateMedia, id: self.$router.history.current.params.id};
            }
          }
        }).finally(() => self.setLoading(false));
      },

      handleNextMedia(evt) {
        const swiperRef = this.$refs.swiper_relate.swiper;
        const indexActive = swiperRef.isEnd;
        if(swiperRef.isEnd && !this.mediaRelateNotdata) {
          this.paramSearchRelateMedia = {...this.paramSearchRelateMedia, pageIndex: this.paramSearchRelateMedia.pageIndex + 1}
        }
      },

      viewMedia(val) {
        this.$router.push({name: 'DetailPageActiveLearn', params: {id: val.bookPageLinkId}});
      },

      getDataRelateMedia() {
        let self = this;
        getListReferentAtvLearn(self.paramSearchRelateMedia).then(res => {
          if(res && res.data && res.data.list.length > 0) {
            // && res.data.length > 0
            self.relateMedia = [...self.relateMedia, ...res.data.list];

          }
          if(res.length === 0) {
            self.mediaRelateNotdata = true;
          }
        })
      },

      directToMediaDetail (data) {
        let linkActive = data.isShowFree && data.isShowFree !== 0;
        if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC && !data.isActived && !linkActive) {
            this.setToggleLoginForm(true);
        } else if(!linkActive && !data.isActived) {
            this.acToggleModalActiveBook(true)
        } else {
          this.$router.push({name: 'DetailPageActiveLearn', params: {id: data.activeLearningId}})
        }
      },

      showModalReadmore () {
        if (this.openModalReadmore) {
          this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
        } else {
          this.openModalReadmore = true
          setTimeout(() => {
            this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
          }, 500);
        }
      },

      handleShareMedia () {
        this.acSetMediaShareInfo({...this.dataPageLink})
        this.acToggleModalShareMedia(true)
      },

      handleDownloadFile (link, name, id) {
        if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC) {
            this.setToggleLoginForm(true);
        } else {
          // console.log('id', id)
          apiUpdateCountdownloadActiveLesson(id)
          // Download full link
          // let lengthLink = link.length
          // let exFile = link.slice(-4, lengthLink)
          this.downloadDocs(link, name, true)
        }
      },

      handleResizeImg (link) {
        return replaceImageResize(link, {width: 521, height: 293})
      }

    }
  }
</script>

<style lang="scss" scoped>
  .count-download{
    margin-left: 10px;
  }
  .count-view{
    margin-right: 15px;
  }
  .lib-detail {
    padding-bottom: 60px;

    &__body {
      padding: 35px 0;
    }

    &__content {
      // padding-top: 15px;

      &__read {
        cursor: pointer;

        &:hover {
          @extend .primary-color;
        }
      }

      &__title {
        padding: 20px 0;
      }

      &__info {
        padding: 20px 0 30px;
      }
     
      &__title, &__info {
        border-bottom: 1px solid $color_border_main;
      }

      &__action {
        a {
          letter-spacing: 0.03em;

          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }

    &__relate {

      &__title {
        margin-bottom: 20px;
      }

      .item {
        
        &__media {
          &:before {
            background: #fff;
          }
        }

        &--lock {
          .item {
            
            &__title {
              @extend .secondary-color-txt;
            }
            // &__icon {
            //   opacity: 1;
            // }
          }
        }

        &__media {
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,.2);
            z-index: 1;
            @extend .effect-transition-fast;
            @extend .effect-hide-hover;
          }
        }

        &__icon {
          opacity: 0;
        }

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          pointer-events: none;
        }

        &__body {
          padding: 10px 0;
        }

        p {
          line-height: 1;
        }

        video {
          max-height: 150px;
        }

        video, audio {
          width: 100%;
          pointer-events: none;
        }

        &:hover {
          .item {
            &__icon {
              opacity: 1;
            }

            &__media {
              &:after {
                @extend .effect-show-hover;
              }
            }
          }
        }
      }
    }

    .video-wrap {
      max-width: 100%;
    }

    .swiper-button-prev, .swiper-button-next {
        height: 100%;
        top: 0;
        display: flex;
        align-items: center;
        background-position: center;
        background-color: rgba(255,255,255,.5);
        width: 40px;
    }

    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;

    }
  }
  .lib-back {
    margin-bottom: 15px;
  }
  .audio-detail {
    max-width: 100%;
  }
  @media screen and ( max-width: 767px ) {
    .lib-detail {

      &__content {

        &__title {
          display: block;
        }

        &__action {
          margin-top: 15px;
        }
      }
    }
  }
</style>
